module.exports = __webpack_public_path__ + "static/media/save.c1f4e35b.svg";